module.exports = __webpack_public_path__ + "img/preview.9abbfe8a.png";